// extracted by css-extract-rspack-plugin
export default {"pagination":"oezWRh","arrow":"zXYNQJ"};